<template lang="pug">
FetchErrorTransition(:isFetching="isFetching" :error="error" :parsedException="parsedException")
  AdvancedSettingsPage(
    :settings="settings" 
    @save="save" 
    :pending="savePending" 
    :businessUnitKey="businessUnitKey" 
    :canViewAuditTrail="canViewAuditTrail"
    )
</template>

<script>
import AdvancedSettingsPage from '@v/settings/application/advanced/AdvancedSettingsPage.vue'
import fetchDataOnMount from '@v/mixins/fetchDataOnMount.js'

export default {
  components: { AdvancedSettingsPage },
  mixins: [
    fetchDataOnMount({
      url: 'settings',
      mapResponse: (instance, response) => {
        instance.settings = response.data.settings
        instance.businessUnitKey = response.data.businessUnitKey
      },
    }),
  ],
  props: {
    canViewAuditTrail: Boolean,
  },
  data() {
    return {
      businessUnitKey: null,
      settings: null,
      savePending: false,
    }
  },
  methods: {
    async save() {
      this.savePending = true
      const settings = this.settings.map(s => ({
        SettingKey: s.SettingKey,
        Values: s.Values,
      }))
      try {
        await this.$apiClient.put(`settings?businessUnitKey=${this.businessUnitKey}`, settings)
        this.$notifySuccess('Settings saved')
      } catch (error) {
        if (error.response.status === 403) {
          this.error =
            'You tried to save settings for a different business unit other than the one you are currently using. Please refresh the page.'
        }
        this.$notifyError('Something went wrong!')
      }
      this.savePending = false
    },
  },
}
</script>
